import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { Container, Row, Col } from 'reactstrap';
import NavigationBar from '../layout/NavigationBar';

class Market extends Component {
    render() {
        const { auth } = this.props;

        if (!auth.uid) return <Redirect to="/welcome" />;

        return (
            <div className={ 'darkMarket' } >
                <NavigationBar activeTab="admin" />
                <div id="page-wrap" className="container" style={{ maxWidth: 1300 }}>
                    <div className="action">
                        <div className="title market_title">
                            <h2>Admin Panel</h2>
                        </div>
                    </div>
                    <Container style={{ maxWidth: 1300 }}>
                        <Row xs="1">
                            <Col className="market" md="9" lg="9">
                            </Col>
                        </Row>
                    </Container>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        auth: state.firebase.auth,
        mode: state.mode,
    };
};

export default connect(mapStateToProps)(Market);
